
export default function CreditsPage(){
    return(
    <>
        
    </>
    );
}